// @ts-nocheck
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { Card } from '@mui/material';
import Grid from '@material-ui/core/Grid';

export default function Error() {
  const navigate = useNavigate();

  return (
    <Grid container direction="column" alignItems="center" justify="center" style={{ minHeight: '100vh' }}>
      <Grid item xs={3}>
        <Card sx={{ padding: '40px' }}>
          <div style={{ alignItems: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px' }}>
              <p className="title" style={{ fontWeight: 'bold', fontSize: '35px' }}>
                {' '}
                Registration unsuccess-full{' '}
              </p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px' }}>
              <p className="titleParagraph " style={{ fontSize: '25px' }}>
                Link expired. Please click here to re-generate the new link to onboard yourself.
              </p>
            </div>

            <div
              style={{ display: 'flex', justifyContent: 'center ', marginTop: '10px', fontSize: '20px' }}
              className="titleParagraphtwo "
            >
              <p> Click here to </p>
              <span
                className=""
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={() => {
                  navigate('/login');
                }}
              >
                &nbsp;Login
              </span>
            </div>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
}
